export default class PseudoDropdown {
  // Basic dropdown replacement
  // Accepts 3 parameters
  // dropdown, openup, and updateSelected
  // dropdown = domElement that holds the required elements
  //      the required elements are elements with the following classes
  //      .pseudo-dropdown__trigger - the element that you click on that opens the dropdown
  //      .pseudo-dropdown__selected - the element that holds the selected value
  //      .pseudo-dropdown__options - the element that contains the options in the dropdown, ideally a ul
  // openup can be true or false.  When false, the dropdown lives up to its name, but if true, the dropdown opens upwards
  // updateSelected can also be true or false.  If true, when you click on an option the selected value is updated to reflect your choice. If false, the selected value never changes. i.e. if the options are links and you just want to follow the link when it's clicked on.

  constructor(dropdown, openup = false, updateSelected = true) {
    this.dropdown = dropdown;
    this.updateSelected = updateSelected;
    this.bindFunctions();
    this.setDropdownElements();

    if(this.allElementsPresent()){
      if(openup){
        this.addUpClass();
      }
      this.attachEvents();
    } else {
      console.log('Cannot init Pseudo Dropdown');
    }
  }

  addUpClass(){
    this.dropdown.classList.add('open-up');
  }

  allElementsPresent(){
    if(!this.dropdownTrigger || !this.selectedOption || !this.options){
      return false;
    }
    return true;
  }

  setDropdownElements(){
    this.dropdownTrigger = this.dropdown.querySelector('.pseudo-dropdown__trigger');
    this.selectedOption = this.dropdown.querySelector('.pseudo-dropdown__selected');
    this.options = this.dropdown.querySelector('.pseudo-dropdown__options');
  }

  attachEvents(){
    this.addSelectEvent();
    this.addOpenCloseEvent();
    this.addUniversalCloseEvent();
  }

  addSelectEvent(){
    [...this.options.querySelectorAll('li')].map( (li)=>{
      li.addEventListener("click", (e)=> this.makeSelected(e));
    })
  }

  addOpenCloseEvent(){
    this.dropdownTrigger.addEventListener("click", this.openClosePseudoDropdown);
  }

  openClosePseudoDropdown(){
    if(this.dropdown.classList.contains('pseudo-dropdown-open')){
      this.dropdown.classList.remove("pseudo-dropdown-open");
    } else {
      this.dropdown.classList.add("pseudo-dropdown-open");
    }
  }

  makeSelected(e){
    this.selectedOption = this.dropdown.querySelector('.pseudo-dropdown__selected a div');

    if(e.target.innerHTML == this.selectedOption.innerHTML){
      this.closeLanguageDropDown();
    }
    if(this.updateSelected){
      this.selectedOption.innerHTML = e.currentTarget.innerHTML;
    }
  }

  bindFunctions(){
    this.makeSelected = this.makeSelected.bind(this);
    this.openClosePseudoDropdown = this.openClosePseudoDropdown.bind(this);
  }

  addUniversalCloseEvent() {
    document.body.removeEventListener("click", this.closePseudoDropdown);
    document.body.addEventListener("click", this.closePseudoDropdown);
  }

  closePseudoDropdown(e){
    let pseudoDropdowns = document.querySelectorAll('.pseudo-dropdown');
    [...pseudoDropdowns].map( (pseudoDropdown)=>{
      if(!pseudoDropdown.contains(e.target)){
        pseudoDropdown.classList.remove("pseudo-dropdown-open");
      }
    });
  }

  closeLanguageDropDown(){
    $(".pseudo-dropdown").removeClass("pseudo-dropdown-open");
  }
}
